export default class ReportChecklistItem {
  constructor(checklistItemId, inputType) {
    this.checklistItemId = checklistItemId;
    this.inputType = inputType;
    this.value = false; //Flag that determines whether a checklist item is marked as a defect or not
  }
}
